import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core'
import {
    SHIKSHA_CLIENT_TYPE_REVENUE_CONTENT,
    SHIKSHA_CLIENT_TYPE_REVENUE_UI,
    SHIKSHA_CLIENT_TYPE_REVENUES,
} from '../constants/shiksha-dashboard.constants'
import type { IShikshaClientTypeRevenue } from '@features/home/models/shiksha-dashboard.model'
import { ShikshaDashboardSubtitleHeaderComponent } from '../shiksha-dashboard-subtitle-header/shiksha-dashboard-subtitle-header.component'

@Component({
    selector: 'app-shiksha-revenue-by-client-type',
    standalone: true,
    templateUrl: './shiksha-revenue-by-client-type.component.html',
    styleUrl: './shiksha-revenue-by-client-type.component.scss',
    imports: [ShikshaDashboardSubtitleHeaderComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShikshaRevenueByClientTypeComponent {
    readonly content = SHIKSHA_CLIENT_TYPE_REVENUE_CONTENT
    readonly uiConfig = SHIKSHA_CLIENT_TYPE_REVENUE_UI
    readonly clientTypeRevenues = input<readonly IShikshaClientTypeRevenue[]>(
        SHIKSHA_CLIENT_TYPE_REVENUES,
    )
    readonly hasRows = computed(() => this.clientTypeRevenues().length > 0)

    sharePercentLabel(sharePercent: number): string {
        const numericSharePercent = Number(sharePercent)
        if (!Number.isFinite(numericSharePercent)) {
            return '0'
        }
        const formattedSharePercent = numericSharePercent.toFixed(1)
        return formattedSharePercent.endsWith('.0')
            ? formattedSharePercent.slice(0, -2)
            : formattedSharePercent
    }

    shareTagAriaLabel(sharePercent: number): string {
        return `${this.uiConfig.shareTagAriaPrefix} ${this.sharePercentLabel(sharePercent)} ${this.uiConfig.shareTagAriaSuffix}`
    }

    trackAriaLabel(label: string, sharePercent: number): string {
        return `${label}, ${this.sharePercentLabel(sharePercent)} ${this.uiConfig.trackAriaSuffix}`
    }

    isSlimFill(sharePercent: number): boolean {
        return sharePercent > 0 && sharePercent < this.uiConfig.slimFillMaximumPercent
    }
}
